import { Submission } from '../../types';
import { getApiBaseUrl } from '../../utils/api-base-url';

export const deleteSigner = async (
  urlSlug: string,
  submissionId: string,
): Promise<Submission> => {
  const response = await fetch(`${getApiBaseUrl()}/submissions/${urlSlug}/${submissionId}/signature/request`, {
    method: 'DELETE',
    headers: { 'Content-Type': 'application/json' },
    credentials: 'include',
  });

  const body = await response.json();

  if (!response.ok || !body.success) {
    const errorMessage = body?.message || 'Failed to delete signer invitation.';
    throw new Error(errorMessage);
  }

  return body.data;
};
